import { Routes } from '@angular/router';
import { paymentLinkGuard } from './guards/payment-link.guard';
import { paymentLinkResolver } from './guards/payment-link.resolver';
import { finalPageGuard } from './guards/final-page.guard';

export const routes: Routes = [
  // Flujo especial de pago de procesador
  {
    path: 'processor-payment',
    loadComponent: () => import('./pages/processor-payment/processor-payment-page.component')
        .then(m => m.ProcessorPaymentPageComponent)
  },
  // Página de error
  {
    path: 'error',
    loadComponent: () => import('./pages/error/error-page.component')
      .then(m => m.ErrorPageComponent)
  },
  // Rutas de resultados
  {
    path: ':linkId/pago-exitoso',
    canActivate: [finalPageGuard],
    loadComponent: () => import('./pages/payment-success/payment-success-page.component')
      .then(m => m.PaymentSuccessPageComponent)
  },
  {
    path: ':linkId/pago-rechazado',
    canActivate: [finalPageGuard],
    loadComponent: () => import('./pages/payment-rejected/payment-rejected-page.component')
      .then(m => m.PaymentRejectedPageComponent)
  },
  {
    path: ':linkId/pago-error',
    canActivate: [finalPageGuard],
    loadComponent: () => import('./pages/payment-error/payment-error-page.component')
      .then(m => m.PaymentErrorPageComponent)
  },
  {
    path: 'processor-payment-success',
    loadComponent: () => import('./pages/payment-success/payment-success-page.component')
        .then(m => m.PaymentSuccessPageComponent)
  },
  // Link de pago - URL con query params Ejm: /?identifier=XXXXXXXX
  {
    path: '',
    loadComponent: () => import('./pages/payment/payment-page.component')
      .then(m => m.PaymentPageComponent),
    canActivate: [paymentLinkGuard],
    resolve: {
      linkData: paymentLinkResolver
    }
  },
  // Link de pago - URL con path Ejm: /XXXXXXXX
  {
    path: ':linkId',
    loadComponent: () => import('./pages/payment/payment-page.component')
      .then(m => m.PaymentPageComponent),
    canActivate: [paymentLinkGuard],
    resolve: {
      linkData: paymentLinkResolver
    }
  },
  // Fallback
  {
    path: '**',
    redirectTo: '/error'
  }
];
